/* eslint-disable */
export const arrowRightIcon = {
  data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.12061 4.84058L14.929 11.6171L9.12061 18.3935" stroke="currentColor" stroke-width="1.4521" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  name: 'arrow-right' as const,
};
